import { Box, Step, StepLabel, Stepper, Typography } from '@mui/material'

const STEPS = ['Uploaded', 'Resolving', 'Ready to review', 'Order created']

function activeStepFromStatus(status) {
  switch (status) {
    case 'queued':
    case 'parsing':
      return 0
    case 'resolving':
      return 1
    case 'ready_for_review':
      return 2
    case 'submitted':
      return 3
    case 'failed':
    case 'cancelled':
      return 1
    default:
      return 0
  }
}

export default function ImportSessionStepper({ status }) {
  const active = activeStepFromStatus(status)
  const isFailed = status === 'failed' || status === 'cancelled'

  return (
    <Box sx={{ mb: 3 }}>
      <Stepper activeStep={active} alternativeLabel>
        {STEPS.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      {isFailed && (
        <Typography variant="body2" color="error" sx={{ mt: 1, textAlign: 'center' }}>
          Import {status}. Check error details below.
        </Typography>
      )}
    </Box>
  )
}
